import { ReactNode } from 'react';

import { FormLabelContainer } from '@components/form-label/form-label';
import { useScopedTranslate } from '@locale/translate';

export const DefaultValueSection = ({ children }: { children: ReactNode }) => {
  const { t } = useScopedTranslate(locale);

  return <FormLabelContainer label={t('defaultValue')}>{children}</FormLabelContainer>;
};

const locale = {
  en: {
    defaultValue: 'Default value',
  },
};
